import { useQuery } from 'react-query';

import { DataRoomUser, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomUsersQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomUsers.Root(guid),
		() => AxiosUtils.getResponseData<DataRoomUser[]>(api.get(CerebroApiEndpoints.DataRoomUsers.Root(guid))),
		{ enabled: guid !== undefined }
	);
}
